import { Employeur } from "src/domain/Employeur";
import { DictionnaireApi } from "src/app/api/DictionnaireApi";
import { callAppAPI } from "src/app/api/AppApiClient";

export const fetchAuthorizedAffilies = async (): Promise<Employeur[]> => {
  return callAppAPI<void>({
    method: "GET",
    url: DictionnaireApi.authorizedAffilies.getUrl(),
  })
    .then(result => {
      return result;
    });
};